<template>
  <v-menu
    v-if="spot.id && writableEntryIds.length"
    offset-y
    left
    :disabled="!atLeastOneOptionAvailable"
    data-cy="spot-detail-batch-menu"
  >
    <v-btn
      slot="activator"
      color="grey--text text--darken-1"
      icon
      class="ma-0"
      :disabled="!atLeastOneOptionAvailable"
    >
      <v-icon
        class="hoverable-icon"
        medium
      >
        more_vert
      </v-icon>
    </v-btn>
    <v-list>
      <v-list-tile>
        <v-list-tile-title>
          <strong
            class="msr--text"
          >{{ $t('forMultiple') + ' ' + $t('decoders') }} ...</strong>
        </v-list-tile-title>
      </v-list-tile>
      <v-divider />
      <!-- Timing -->
      <v-list-tile
        v-if="!spot.expired && !isTagged"
        data-cy="spot-detail-batch-action-timing"
        @click="$emit('timing')"
      >
        <v-list-tile-avatar>
          <v-icon
            :class="{
              'grey--text': !allEntriesUseTiming(entries),
              'msr--text': allEntriesUseTiming(entries),
            }"
          >
            timer
          </v-icon>
        </v-list-tile-avatar>
        {{ $t('timing') }}
      </v-list-tile>
      <!-- Hotrotation -->
      <!-- FIXME: Writable entries only? -->
      <v-list-tile
        v-if="!spot.expired && !isClosingTimeRadioSpot(spot) && !isTagged"
        data-cy="spot-detail-batch-action-hotrotation"
        @click="$emit('hotrotating')"
      >
        <v-list-tile-avatar>
          <v-icon
            v-if="!allEntriesUseHotrotation(entries)"
            class="grey--text"
          >
            star_outline
          </v-icon>
          <v-icon
            v-if="allEntriesUseHotrotation(entries)"
            class="msr--text"
          >
            star
          </v-icon>
        </v-list-tile-avatar>
        {{ $t('hotrotation') }}
      </v-list-tile>
      <!-- Editable fields -->
      <v-list-tile
        v-if="allEntriesHaveOverlayData(entries)"
        @click="$emit('overlayediting')"
      >
        <v-list-tile-avatar>
          <v-icon class="grey--text">
            edit
          </v-icon>
        </v-list-tile-avatar>
        {{ $t('customize') }}
      </v-list-tile>
      <!-- Removal -->
      <v-list-tile
        v-if="!isTagged"
        data-cy="spot-detail-batch-action-removal"
        @click="$emit('removing')"
      >
        <v-list-tile-avatar>
          <v-icon class="grey--text">
            block
          </v-icon>
        </v-list-tile-avatar>
        {{ $t('deactivate') }}
      </v-list-tile>
      <!-- Filter by timeframe -->
      <timeframe-filter-list-tile :entries="entries" />
    </v-list>
  </v-menu>
</template>

<script>
import {isClosingTimeRadioSpot} from '@/mixins/identifiers.js';
import {isTaggedContent} from '@/mixins/content.js';
import commonEntry from '@/mixins/commonEntry.js';

import TimeframeFilterListTile from '@/components/TimeframeFilterListTile';

export default {
  components: {
    TimeframeFilterListTile,
  },
  mixins: [commonEntry],
  props: {
    spot: {
      type: Object,
      required: true,
    },
    entries: {
      type: Array[Object],
      required: true,
    },
  },
  computed: {
    atLeastOneOptionAvailable() {
      return (
        (!this.spot.expired && !this.isTagged) ||
        (!this.spot.expired &&
          !this.isClosingTimeRadioSpot &&
          !this.isTagged) ||
        this.allEntriesHaveOverlayData(this.entries) ||
        !this.isTagged
      );
    },
    isTagged() {
      return isTaggedContent(this.spot);
    },
    /**
     * Return list of SpotEntries where User has write access to Decoder.
     */
    writableEntries() {
      if (!this.entries.length) {
        return [];
      }
      let writableEntries = this.entries.filter(
        (entry) => !entry.decoder.read_only
      );
      return writableEntries;
    },
    /**
     * Return list of SpotEntry ids where User has write access to Decoder.
     */
    writableEntryIds() {
      const ids = this.writableEntries.map((entry) => entry.id);
      return ids;
    },
  },
  methods: {
    isClosingTimeRadioSpot: isClosingTimeRadioSpot,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SpotDetail/SpotDetailBatchMenu.vue